(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__favlyGalleryDefer) return;
    window.__favlyGalleryDefer = true;

    function hydrate(img) {
      if (img.dataset.srcset) { img.setAttribute('srcset', img.dataset.srcset); img.removeAttribute('data-srcset'); }
      if (img.dataset.src) { img.setAttribute('src', img.dataset.src); img.removeAttribute('data-src'); }
    }

    function init() {
      document.querySelectorAll('[id^="Slider-Gallery-"]').forEach(function (list) {
        if (!list.querySelector('img[data-src]')) return;
        var hydrateAll = function () {
          list.querySelectorAll('img[data-src]').forEach(hydrate);
        };
        if ('IntersectionObserver' in window) {
          var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) { hydrate(entry.target); observer.unobserve(entry.target); }
            });
          }, { root: list });
          list.querySelectorAll('img[data-src]').forEach(function (img) { observer.observe(img); });
        } else {
          hydrateAll();
        }
        var section = list.closest('[id^="shopify-section-"]') || list;
        section.addEventListener('pointerdown', hydrateAll, { once: true });
        section.addEventListener('keydown', hydrateAll, { once: true });
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  function normalizeLegalGuaranteeHash(value) {
    if (!value) return '';
    const hashIndex = value.indexOf('#');
    let hash = hashIndex >= 0 ? value.slice(hashIndex + 1) : String(value).replace(/^#/, '');
    try {
      hash = decodeURIComponent(hash);
    } catch (error) {}
    return hash.replace(/\s+/g, '').toLowerCase();
  }

  function bindLegalGuaranteePopup() {
    const modals = document.querySelectorAll('#LegalGuaranteeModal');
    if (!modals.length) return;
    if (modals.length > 1) {
      for (let i = 0; i < modals.length - 1; i++) {
        modals[i].remove();
      }
    }

    const modal = document.getElementById('LegalGuaranteeModal');
    if (!modal || typeof modal.show !== 'function') return;

    function revealLegalGuaranteeImage() {
      const img = modal.querySelector('.legal-guarantee-modal__image[data-src]');
      if (!img) return;
      if (img.dataset.srcset) { img.setAttribute('srcset', img.dataset.srcset); img.removeAttribute('data-srcset'); }
      img.setAttribute('src', img.dataset.src);
      img.removeAttribute('data-src');
    }

    const trigger = modal.getAttribute('data-trigger') || '';
    const normalizedTrigger = normalizeLegalGuaranteeHash(trigger);
    const links = document.querySelectorAll('.footer__menu a');

    links.forEach(function(link) {
      if (link.dataset.legalGuaranteeBound === 'true') return;

      const href = link.getAttribute('href') || '';
      const matchesHash = normalizedTrigger && normalizeLegalGuaranteeHash(href) === normalizedTrigger;
      const marked = link.hasAttribute('data-legal-guarantee-popup');
      if (!matchesHash && !marked) return;

      link.dataset.legalGuaranteeBound = 'true';
      link.setAttribute('aria-haspopup', 'dialog');
      link.setAttribute('aria-controls', 'LegalGuaranteeModal');
      link.addEventListener('click', function(event) {
        event.preventDefault();
        revealLegalGuaranteeImage();
        modal.show(link);
      });
    });

    if (
      modal.dataset.hashOpened !== 'true' &&
      normalizedTrigger &&
      normalizeLegalGuaranteeHash(window.location.hash) === normalizedTrigger
    ) {
      modal.dataset.hashOpened = 'true';
      const opener = document.querySelector('.footer__menu a[aria-controls="LegalGuaranteeModal"]');
      revealLegalGuaranteeImage();
      modal.show(opener || document.body);
    }
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('modal-dialog').then(bindLegalGuaranteePopup);
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindLegalGuaranteePopup);
  } else {
    bindLegalGuaranteePopup();
  }

  document.addEventListener('shopify:section:load', bindLegalGuaranteePopup);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  class SortByHandler extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('.disclosure__link').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.button.innerHTML = event.target.dataset.name;
      event.target.closest('ul').querySelector('.animation-underline--active').classList.remove("animation-underline--active");
      event.target.classList.add("animation-underline--active");
      if(document.getElementById('SortBy')){
        document.getElementById('SortBy').value = event.target.dataset.value;
        document.getElementById('FacetFiltersForm').dispatchEvent(new Event('input'));
      }
      else{
        document.getElementById('SortBy-mobile').value = event.target.dataset.value;
        document.getElementById('FacetFiltersFormMobile').dispatchEvent(new Event('input'));
      }
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      var _this = this;
      setTimeout(function(){_this.hidePanel();}, 150)
    }
  }

  customElements.define('sort-by-select', SortByHandler);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  class SortByHandler extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('.disclosure__link').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.button.innerHTML = event.target.dataset.name;
      event.target.closest('ul').querySelector('.animation-underline--active').classList.remove("animation-underline--active");
      event.target.classList.add("animation-underline--active");
      document.getElementById('SortBy').value = event.target.dataset.value;
      document.getElementById('FacetFiltersForm').dispatchEvent(new Event('input'));
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      var _this = this;
      setTimeout(function(){_this.hidePanel();}, 150)
    }
  }

  customElements.define('sort-by-select', SortByHandler);

  } catch(e) { console.error(e); }
})();
})();
